import { removeBackground as removeBg } from '@imgly/background-removal';

class BackgroundRemoval {
  constructor(canvasManager) {
    this.canvasManager = canvasManager;
    this._processing = false;
  }

  isProcessing() {
    return this._processing;
  }

  // Bild in voller Originalauflösung als Blob holen
  // Nutzt Fabric.js toDataURL() um CORS-Probleme zu vermeiden
  async _getImageBlob(obj) {
    // Fabric.js toDataURL() handled cross-origin intern korrekt
    const dataUrl = obj.toDataURL({ format: 'png', multiplier: 1 });
    if (!dataUrl || dataUrl === 'data:,') {
      throw new Error('Kein Bildelement gefunden oder Bild konnte nicht gelesen werden');
    }

    // DataURL in Blob konvertieren
    const response = await fetch(dataUrl);
    const blob = await response.blob();
    if (!blob || blob.size === 0) {
      throw new Error('Blob-Konvertierung fehlgeschlagen');
    }
    return blob;
  }

  async removeBackground(obj, onProgress) {
    if (!obj || obj.type !== 'image') return;
    if (this._processing) return;
    this._processing = true;

    try {
      const imageBlob = await this._getImageBlob(obj);

      const resultBlob = await removeBg(imageBlob, {
        progress: (key, current, total) => {
          if (onProgress) onProgress(key, current, total);
        },
      });

      const dataUrl = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(resultBlob);
      });

      await new Promise((resolve) => {
        obj.setSrc(dataUrl, () => {
          obj.set('dirty', true);
          this.canvasManager.canvas.renderAll();
          this.canvasManager.canvas.fire('object:modified', { target: obj });
          resolve();
        }, { crossOrigin: 'anonymous' });
      });
    } finally {
      this._processing = false;
    }
  }
}

export default BackgroundRemoval;
